module.exports = __webpack_public_path__ + "img/logo-vrjmof2022.56f657a8.svg";